import React, { useEffect, useState } from 'react'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import styles from './LoadingAudiences.module.scss'
import { superAxiosRequest } from 'axiosApi'
import LineChartTable from './LineChartTable/LineChartTable'
import ContentHeader from 'components/ContentBox/Global/ContentHeader'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import { observer } from 'mobx-react'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import { useHistory } from 'react-router-dom'

const LoadingAudiences = () => {
  const [isLoading, setIsLoading] = useState({})
  const [groupCatalog, setGroupCatalog] = useState({})
  const [total, setTotal] = useState(0)
  const [oldTotal, setOldTotal] = useState(0)
  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: groupCatalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },

    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
			isRequired: true,
    },
    {
      type: 'select-multi',
      label: 'Уровень группы',
      placeholder: 'Уровень группы',
      values: groupCatalog?.skill_levels,
      sort_key: 'name',
      nameState: 'skill_level',
    },
    {
      type: 'type_selector',
      nameState: 'online',
      label: 'Формат',
      values: [
        { id: 2, name: 'Все группы' },
        { id: 1, name: 'Онлайн' },
        { id: 0, name: 'Офлайн' },
      ],
    },
  ]

  const [myData, setMyData] = useState(false)
  const [myOldData, setMyOldData] = useState()
  const [date, setDate] = useState({
    from: new Date(new Date().setDate(1)),
    until: new Date(
      new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0),
    ),
  })

  useEffect(() => {
    sendFerstReqest()
  }, [])

  useEffect(() => {
    sendAllRequests(filter)
  }, [filter])

  const getMaxHour = (maxMinute) => {
    let maxHour = Math.ceil(maxMinute / 60 / 10) * 10
    return maxHour > 10 ? maxHour : 10
  }

  const sendAllRequests = (e) => {
    sendRequest(e, 'progress_report/classrooms_loading', setMyData, setTotal)
    sendRequest(
      e,
      'progress_report/classrooms_loading_old',
      setMyOldData,
      setOldTotal,
    )
  }
  const sendRequest = (param, link, setData, setTotal) => {
    if (param?.date_until && param?.date_from) {
      setIsLoading(true)
      let apiConf = {
        method: 'get',
        link: link,
        params: {
          ...param,
        },
      }
      delete apiConf.params.is_active
      if (apiConf.params.skill_level && apiConf.params.skill_level.length > 0)
        apiConf.params.skill_level = `[${apiConf.params.skill_level.map((item) => item)}]`
      else delete apiConf.params.skill_level
      if (apiConf.params.course_level && apiConf.params.course_level.length > 0)
        apiConf.params.course_level = `[${apiConf.params.course_level.map((item) => item)}]`
      else delete apiConf.params.course_level
      if (apiConf.params.location && apiConf.params.location.length > 0)
        apiConf.params.location = `[${apiConf.params.location.map((item) => item)}]`
      else delete apiConf.params.location
      superAxiosRequest(apiConf).then((res) => {
        setTotal(res.data.total)
        setDate({
          from: new Date(apiConf.params.date_from),
          until: new Date(apiConf.params.date_until),
        })
        let maxMinute = 0
        res.data.result.forEach((element) => {
          if (element.minutes > maxMinute) maxMinute = element.minutes
        })

        const maxHours = getMaxHour(maxMinute)
        const sectionsLenght = maxHours / 10
        let locationsData = [...res.data.result]
        let newState = []
        let inddex = 0

        while (Boolean(locationsData[0])) {
          let id = locationsData[0].location.id
          newState[inddex] = {
            location: locationsData[0].location,
            audience: [],
            total_minutes: 0,
          }
          locationsData = locationsData.filter((item) => {
            if (item.location.id !== id) return true
            else {
              newState[inddex].total_minutes = (
                Number(newState[inddex].total_minutes) +
                Number((item.minutes / 60).toFixed(2))
              ).toFixed(2)
              newState[inddex].audience.push({
                minutes: item.minutes,
                id: item.id,
                name: item.name,
                hours: (item.minutes / 60).toFixed(2),
                lenght: item.minutes / 60 / sectionsLenght,
              })
              return false
            }
          })
          inddex++
        }
        setData({
          settings: {
            maxValue: maxHours,
            interval: sectionsLenght,
          },
          rows: newState,
        })
        setIsLoading(false)
      })
    }
  }
  const sendFerstReqest = () => {
    superAxiosRequest({
      method: 'get',
      link: 'progress_report/classrooms_loading',
    })
      .then(({ data }) => {
        setGroupCatalog(data)
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/loading_audiences') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Локация',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Аудитория',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Колличиство ак.ч.',
          ...ExcelRowsParams.headerRowParam,
        },
      ]

      let tableData = []

      let merges = []
      let wscols = [{ wch: 35 }, { wch: 20 }, { wch: 20 }]
      let currentRow = 1
      data.forEach((row) => {
        merges.push({
          s: { r: currentRow, c: 0 },
          e: { r: currentRow + row.audience.length - 1, c: 0 },
        })
        row.audience.forEach((item) => {
          currentRow++
          tableData.push([
            {
              v: `${row.location.name}`,
              ...ExcelRowsParams.tableRowParam.firstCell,
            },
            {
              v: `${item.name}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
            {
              v: `${item.hours}`,
              ...ExcelRowsParams.tableRowParam.cell,
            },
          ])
        })
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Загрузка аудиторий.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length

  return (
    <div className={styles.page}>
      <ContentHeader title='Загрузка аудиторий' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>
      {isLoading ? (
        <Loader />
      ) : myData ? (
        <>
          <div style={{ padding: '10px' }}>
            {myData.rows && (
              <ExportExcelButton
                data={myData.rows}
                downloadExcel={downloadExcel}
              />
            )}
          </div>
          <LineChartTable
            chartData={myData}
            title={`Загрузка аудиторий в часах c ${timeConverter(date.from, 'day')} по ${timeConverter(date.until, 'day')}`}
          />
          <div className={styles.total}>
            Итого по всем локациям: {Math.round(total / 60)} ч.
          </div>
          <div style={{ padding: '10px' }}>
            {myOldData.rows && (
              <ExportExcelButton
                data={myOldData.rows}
                downloadExcel={downloadExcel}
              />
            )}
          </div>
          <LineChartTable
            chartData={myOldData}
            title={`Загрузка аудиторий в часах c ${timeConverter(date.from, 'day')} по ${timeConverter(date.until, 'day')}`}
          />
          <div className={styles.total}>
            Итого по всем локациям: {oldTotal / 60} ч.
          </div>
        </>
      ) : (
        <h1 style={{ textAlign: 'center' }}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(LoadingAudiences)
